import type { bankingApiSpec } from "@wingspanhq/wingspan-api-types";

export const selectorTaxWithholdingAccount = (
  internalAccount: bankingApiSpec.InternalAccount
) =>
  internalAccount.type === "TaxWithholding" &&
  (internalAccount.status === "Active" || internalAccount.status === "Pending");
